<template>
  <div class="w-full h-full realative p-5">
    <!-- <ThankYouCanvas>
      <ThankYouLayoutSwat></ThankYouLayoutSwat>
    </ThankYouCanvas> -->
    <div class="">
      <PhoneArea :maxWidth="414" class="full mx-2">
        <ThankYouCanvas>
          <DemoLayoutSwat></DemoLayoutSwat>
        </ThankYouCanvas>
      </PhoneArea>
    </div>

    <!--
    <div class="democanvas">
      <ThankYouCanvas></ThankYouCanvas>
    </div>
    -->

  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  mounted () {
    this.$root.$emit('play-move', { name: 'Warming Up' })
    window.dispatchEvent(new Event('resize'))
  }
}
</script>

<style>
.democanvas{
  width: 100%;
  max-width: 480px;
  height: 480px;
}
</style>
